import { create } from "../../../../../common/utils/zustand_state_manager";
import { SetFunction, SetFunctionImpl } from "../../../../../common/utils/filters_utils";
import { CentroCustoDropDown } from "../../../../../common/domain/models/centro_custo_dropdown";

type State = {
  IdContrato: number;
  DocumentosPesquisa: number;
  AssinadoPesquisa: number;
  FornecedorPesquisa: number;
  StatusPesquisa: number;
  centroDeCusto: number[];
  centroDeCustoLista: CentroCustoDropDown[] | undefined;
  NDocumentoPesquisa: string;
};

type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
  setDocumentosPesquisa: SetFunction<number>;
  setAssinadoPesquisa: SetFunction<number>;
  setFornecedorPesquisa: SetFunction<number>;
  setStatusPesquisa: SetFunction<number>;
  setCentroDeCusto: SetFunction<number[]>;
  setCentroDeCustoLista: SetFunction<CentroCustoDropDown[]>;
  setNDocumentoPesquisa: SetFunction<string>;
};

export const initialFiltersValues: State = {
  IdContrato: 0,
  DocumentosPesquisa: 0,
  FornecedorPesquisa: 0,
  NDocumentoPesquisa: "",
  StatusPesquisa: 0,
  centroDeCusto: [],
  centroDeCustoLista: undefined,
  AssinadoPesquisa: 4,
};

export const useContratoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,
  setDocumentosPesquisa: (vfn) => SetFunctionImpl(set, 'DocumentosPesquisa', vfn),
  setAssinadoPesquisa: (vfn) => SetFunctionImpl(set, 'AssinadoPesquisa', vfn),
  setNDocumentoPesquisa: (vfn) => SetFunctionImpl(set, 'NDocumentoPesquisa', vfn),
  setFornecedorPesquisa: (vfn) => SetFunctionImpl(set, 'FornecedorPesquisa', vfn),
  setStatusPesquisa: (vfn) => SetFunctionImpl(set, 'StatusPesquisa', vfn),
  setCentroDeCusto: (vfn) => SetFunctionImpl(set, 'centroDeCusto', vfn),
  setCentroDeCustoLista: (vfn) => SetFunctionImpl(set, 'centroDeCustoLista', vfn),

  setFilters: (filters) => set((state) => ({ ...state, ...filters })),
  clearFilters: () => set((state) => ({
    ...initialFiltersValues,
    centroDeCustoLista: state.centroDeCustoLista
  })),
}));